export class DocumentUploadRequestModel {
    public documentTypeId?: number;
    public documentId?: string;
    public documentDescription?: string;
    public documentDate?: Date;
    public documentName?: string;
    public documentType?: string;
    public documentData?: string | ArrayBuffer | null;
  }
